<template>
    <div
        v-show="hasFilters"
        class="l-ss-c-filters-sort-container">
        <div class="l-ss-c-filters-top-container">
            <div class="l-ss-c-filters-top-actions">
                <slot name="actions-before"></slot>
                <span
                    class="l-ss-c-filters-found-items"
                    v-if="$screen.isMobile === false && !filterPositionLeft">
                    {{ $t('results.foundNumberItems', [computedTotal]) }}
                </span>

                <sort
                    v-if="showSorting && $configuration.isSortVisible"
                    class="l-ss-c-filters-sort"
                    :sort-by="sortBy"
                    :sort-dest="sortDest"
                    @result-sort-click="params => $emit('result-sort-click', params)"
                    @sort-change="params => $emit('sort-change', params)"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Sort from '../../../core/components/sort';

    const DEFAULT_FILTERS_LENGTH = 2;

    export default {
        components: {
            Sort,
        },
        props: {
            sortBy: {
                type: String,
                default: '',
            },
            sortDest: {
                type: String,
                default: '',
            },
            showSorting: {
                type: Boolean,
                default: false,
            },
            filterPositionLeft: {
                type: Boolean,
                default: false,
            },
            filters: { // Backend response allowed filters list
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                TOP_FILTERS_LENGTH: DEFAULT_FILTERS_LENGTH,
            };
        },
        computed: {
            topFiltersLength() {
                return !this.$screen.isMobile ? this.TOP_FILTERS_LENGTH : 0;
            },
            hasFilters() {
                return !!this.filters.length;
            },
            checkFilters() {
                return this.filters.filter(item => !this.$configuration.hiddenFilters.includes(item.name));
            },
            topFilters() {
                return this.checkFilters.slice(0, this.topFiltersLength);
            },
        },
    };
</script>
